export function normalizeOption(key, option) {
    var _a, _b, _c;
    if (typeof option === "string") {
        return { key, label: option, disabled: false, required: false };
    }
    if ((_a = option.options) === null || _a === void 0 ? void 0 : _a.disabled) {
        return null;
    }
    return {
        key,
        label: option.label,
        disabled: Boolean((_b = option.options) === null || _b === void 0 ? void 0 : _b.disabled),
        required: Boolean((_c = option.options) === null || _c === void 0 ? void 0 : _c.required),
    };
}
export function getEnabledOptions(field) {
    if (!(field === null || field === void 0 ? void 0 : field.options) || typeof field.options !== "object") {
        return [];
    }
    const items = [];
    Object.entries(field.options).forEach(([key, option]) => {
        const normalized = normalizeOption(key, option);
        if (normalized) {
            items.push(normalized);
        }
    });
    return items;
}
export function getTaxLabel(financeType, offerType) {
    if (offerType === "company" && financeType !== "loan") {
        return "netto";
    }
    return "brutto";
}
export function parseMoneyInput(value) {
    const digits = value.replace(/\s/g, "").replace(/[^\d]/g, "");
    return digits ? Number(digits) : 0;
}
export function clampStepperValue(value, min, max, step) {
    const clamped = Math.min(max, Math.max(min, value));
    if (step <= 0) {
        return clamped;
    }
    const stepsFromMin = Math.round((clamped - min) / step);
    return Math.min(max, Math.max(min, min + stepsFromMin * step));
}
export function getPeriodDisplay(months, label) {
    if (label && label.includes("/")) {
        const [monthsLabel, ...rest] = label.split("/").map((part) => part.trim());
        return { monthsLabel, yearsLabel: rest.join(" / ") };
    }
    const years = Math.round(Number(months) / 12);
    const yearsLabel = `${years} ${years === 1 ? "rok" : years < 5 ? "lata" : "lat"}`;
    return { monthsLabel: months, yearsLabel };
}
export function formatPeriodLabel(months, label) {
    const { monthsLabel, yearsLabel } = getPeriodDisplay(months, label);
    return `${monthsLabel} / ${yearsLabel}`;
}
